import { useState, useCallback } from "react";
import { GetPerson } from "../../services/fhir/person/GetPerson";
import { toast } from "react-toastify";

interface UseTermsReturn {
  person: any;
  termsDialog: boolean;
  isOpenTermDialog: boolean;
  terminateAccount: boolean | undefined;
  termRefused: boolean;
  loading: boolean;
  setIsOpenTermDialog: (value: boolean) => void;
  setTerminateAccount: (value: boolean | undefined) => void;
  fetchPersonData: (username: string) => Promise<void>;
}

export const useTerms = (): UseTermsReturn => {
  const [person, setPerson] = useState<any>();
  const [termsDialog, setTermsDialog] = useState(false);
  const [isOpenTermDialog, setIsOpenTermDialog] = useState(false);
  const [terminateAccount, setTerminateAccount] = useState<boolean>();
  const [loading, setLoading] = useState(false);

  const termRefused = person?.extension?.find((item: any) =>
    item.url.includes("termRefused")
  )?.valueBoolean;

  const fetchPersonData = useCallback(async (username: string) => {
    setLoading(true);
    try {
      const response = await GetPerson({
        identifier: username,
      });

      setTermsDialog(!response?.active);
      setPerson(response);
    } catch (error) {
      toast.error("Erro ao carregar dados da pessoa");
      console.error("Erro ao carregar dados da pessoa:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    person,
    termsDialog,
    isOpenTermDialog,
    terminateAccount,
    termRefused,
    loading,
    setIsOpenTermDialog,
    setTerminateAccount,
    fetchPersonData,
  };
};
